import { Component } from "../../../modules/Core/Component";
import templateDefault from "../../templates/default/widgets/recently_viewed";
import Services from "../../Services/Services";

const MAX_ITEMS = 15;

export default class RecentlyViewed extends Component {
  id = "recently-viewed";

  template = templateDefault;

  onLoad(data) {
    super.onLoad(data);

    this.getRecentlyViewed();
  }

  getRecentlyViewed() {
    this.setData({ "default.productsLoaded": false });

    const viewed = this.getHelpers("state").get("viewed", null);

    if (!viewed) {
      this.setData({
        "default.products": [],
        "default.productsLoaded": true,
      });
      return;
    }

    const slugs = [...new Set(viewed.split(",").filter(Boolean))].slice(
      -MAX_ITEMS,
    );

    Services.get("hook").then(([service]) => {
      const promises = slugs.map((slug) =>
        service.exec("product", {
          params: { slug },
        }),
      );

      Promise.all(promises)
        .then((responses) => {
          const devHelper = this.getHelpers("dev");
          const currentSlug = this.getPage().getParam("slug");

          const products = responses
            .map((response) => response.getData())
            .filter(
              (product) =>
                product &&
                devHelper.getObjectValue(product, "_values.active", false) &&
                devHelper.getObjectValue(product, "_values.slug") !==
                  currentSlug,
            )
            .reverse()
            .slice(0, MAX_ITEMS);

          this.setData({
            "default.products": products,
            "default.productsLoaded": true,
          });
        })
        .catch(() => {
          this.setData({
            "default.products": [],
            "default.productsLoaded": true,
          });
        });
    });
  }
}
